// extracted by mini-css-extract-plugin
export default {"tableCardContent":"TableCardBody_tableCardContent__g0JjI","tableCardBody":"TableCardBody_tableCardBody__DExhS","subTableCardBody":"TableCardBody_subTableCardBody__cCQBw"};